/**
 * common helper function
 */
class Helper {
  constructor() {
    this.siteURL = `${window.location.protocol}//${window.location.host}${process.env.PUBLIC_URL}`;
  }

  /**
   * Base64 email ID and decode from btoa
   * @param {*} email
   */

  openEmail(email) {
    window.location.href = atob(email);
  }
  /**
   * validate email address
   * @param mail - mail id
   */
  validateEmail(mail) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
  }

  /**
   * User personal data
   */
  userData() {
    return {
      passport: null,
      nextgen: null,
    };
  }

  /**
   * Allows Numbers, Alphabets and space
   * @param {*} e
   */
  allowAlphaNumericSpace(e) {
    const code = 'charCode' in e ? e.charCode : e.keyCode;
    if (
      code !== 32 && // space
      !(code > 47 && code < 58) && // numeric (0-9)
      !(code > 64 && code < 91) && // upper alpha (A-Z)
      !(code > 96 && code < 123)
    ) {
      e.preventDefault();
    }
  }

  /**
   * Allows Number and Plus
   * @param {*} e
   */
  allowNumberPlus(e) {
    const code = 'charCode' in e ? e.charCode : e.keyCode;
    if (
      code !== 32 && // space
      code !== 43 && // plus
      code !== 45 && // hyphen
      !(code > 47 && code < 58)
    ) {
      e.preventDefault();
    }
  }

  /**
   * Scrolls the window to next step
   */
  scrollTo(ref) {
    window.scrollTo({ top: ref.current.offsetTop, behavior: 'smooth' });
  }

  /**
   * Change the path
   * @param {*} props
   * @param {*} path
   */
  doPathChange(e, props, path, state = null) {
    let o = {};
    o.pathname = path;
    if (state) {
      o.state = state;
    }
    props.history.push(o);
    e.preventDefault();
  }

  /**
   * Change the path
   * @param {*} props
   * @param {*} path
   */
  pathChange(props, path) {
    props.history.push({
      pathname: path,
    });
  }

  /**
   * Redirect to external page
   * @param {*} url
   */
  redirect(url) {
    if (url) {
      window.location.href = url;
    }
  }

  /**
   * On keypress avoid space
   * @param {*} event
   */
  keypressAvoidSpace(event) {
    if (event.key === 32) {
      event.preventDefault();
    }
  }

  /**
   * Format chatbot data
   * @param {*} nextgen
   * @param {*} realmName
   * @param {*} userTypeExternal
   * @returns
   */
  getChatBotPayload(nextgen = null, realmName = null, userTypeExternal = null) {
    let payload = {
      userType:
        realmName && userTypeExternal && realmName !== userTypeExternal
          ? 'internal'
          : 'external',
      userInfo: {},
    };
    if (realmName && userTypeExternal && realmName !== userTypeExternal) {
      payload.userInfo = {
        email: nextgen['userName'],
        displayName: `${nextgen['givenName']} ${nextgen['familyName']}`,
        firstName: nextgen['givenName'],
        lastName: nextgen['familyName'],
      };
    }
    payload.userLocation = 'privacy-portal';
    return payload;
  }

  /**
   * Get portal locale
   * @param {*} locale
   * @returns - locale
   */
  getPortalLocale(locale) {
    return locale.cclc ? locale.cclc : locale.rcclc;
  }

  /**
   * Get query variable
   * @param {*} url
   * @param {*} variable
   * @returns
   */
  getQueryVariable = (url, variable) => {
    if (url) {
      let query = url.substring(1);
      let vars = query.split('&');
      for (let value of vars) {
        let pair = value.split('=');
        if (pair[0] === variable) {
          return pair[1];
        }
      }
    }
    return false;
  };

  replaceEmailWithFlower(emailAddress) {
    return emailAddress.replace(/(\w{3})[\w.-]+@([\w.]+\w)/, '$1***@$2');
  }

  /**
   * get query params value
   * @param {*} query
   * @returns
   */
  getQueryParamsValue(query = null) {
    query = query
      ? query.replace('?', '')
      : window.location.search.replace('?', '');
    return query
      .split('&')
      .map((e) => e.split('=').map(decodeURIComponent))
      .reduce((r, [k, v]) => ((r[k] = v), r), {});
  }

  encryptString(data) {
    const CryptoJS = require('crypto-js');
    return CryptoJS.AES.encrypt(JSON.stringify(data), '3456781239')
      .toString()
      .replace('+', 'xMl3Jk')
      .replace('/', 'Por21Ld')
      .replace('=', 'Ml32');
  }
}
export default new Helper();
